import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "16", height: "16", x: "4", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 11h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 3v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 19-2 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 22-2-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 15h0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 15h0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Train";
const Train = memo(themed(Icon));
export {
  Train
};
//# sourceMappingURL=train.js.map
